export const providerCategory = {
  CREDITCARD: 'Credit Card',
  WALLET: 'Wallet',
  CRYPTO: 'Crypto',
  OTHER: 'Other',
  INSTANTBANKING: 'Instant Banking',
  VOUCHER: 'Voucher'
}

const PROVIDERS = {
  OPEN_BANKING: 'Open Banking',
  REVOLUT_PAY: 'RevolutPay',
  REVOLUT_PAY_SPACED: 'Revolut Pay',
  N26: 'N26',
  WISE: 'Wise'
}

export const SUPPORTED_PROVIDERS = Object.values(PROVIDERS)
